import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SafeUrlPipe } from '@shared/pipes/safe-url.pipe';
import { JedsMenuService } from '@shared/service/app/jeds-menu.service';
import { PwaService } from '@shared/service/app/pwa.service';
import { DosDigitosPipe } from '@shared/pipes/dos-digitos.pipe';
import { LectorQrComponent } from './lector-qr/lector-qr.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { EnviarEmailModalComponent } from './enviar-email-modal/enviar-email.component';
import { MatChipsModule } from '@angular/material/chips';
import { EnviarEmailModalService } from './enviar-email-modal/enviar-email.service';
import { QuillModule } from 'ngx-quill';
import { AppAlertService } from '@shared/service/app/alert.service';
import { SpinnerComponent } from './spinner/spinner.component';
import { GridFilterComponent } from './grid-filter/grid-filter.component';
import { InputFormatDirective } from './input-format/input-format.directive';
import { DateMaskDirective } from '@shared/directives/date-mask.directive';
import { TimeMaskDirective } from '@shared/directives/time-mask.directive';
import { FormateadorService } from '@shared/service/app/formateador.service';
import { EditTableGridComponent } from './edit-table-grid/edit-table-grid.component';
import { MatSelectModule } from '@angular/material/select';
import { ToggleSwitchComponent } from './toggle-switch/toggle-switch.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FilesManagerComponent } from './files-manager/files-manager.component';
import { FileNamePipe } from '@shared/pipes/file-name.pipe';
import { SectionTitleComponent } from './section-title/section-title.component';
import { SectionIconTitleComponent } from './section-icon-title/section-icon-title.component';
import { BotonDinamicoComponent } from './boton-dinamico/boton-dinamico.component';
import { FuseAlertComponent } from '@fuse/components/alert';
import { CommandPaletteComponent } from './command-palette/command-palette.component';

@NgModule({
    declarations: [
        FileNamePipe,
        SafeUrlPipe,
        LectorQrComponent,
        EnviarEmailModalComponent,
        GridFilterComponent,
        InputFormatDirective,
        DateMaskDirective,
        TimeMaskDirective,
        EditTableGridComponent,
        ToggleSwitchComponent,
        FilesManagerComponent,
        SectionTitleComponent,
        SectionIconTitleComponent,
        BotonDinamicoComponent,
        DosDigitosPipe,
        CommandPaletteComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatPaginatorModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatInputModule,
        MatFormFieldModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDividerModule,
        MatAutocompleteModule,
        OverlayModule,
        PortalModule,
        ZXingScannerModule, // Importa ZXingScannerModule aquí
        MatChipsModule,
        MatSelectModule,
        FormsModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatSortModule,
        MatDialogModule,
        MatRadioModule,
        MatDatepickerModule,
        QuillModule.forRoot(), // Configuración global del módulo
        SpinnerComponent,
        FuseAlertComponent,
    ],
    exports: [
        SafeUrlPipe,
        FileNamePipe,
        LectorQrComponent, // Exporta LectorQrComponent para que esté disponible en otros módulos
        EnviarEmailModalComponent,
        SpinnerComponent,
        GridFilterComponent,
        InputFormatDirective,
        DateMaskDirective,
        TimeMaskDirective,
        EditTableGridComponent,
        ToggleSwitchComponent,
        FilesManagerComponent,
        SectionTitleComponent,
        SectionIconTitleComponent,
        BotonDinamicoComponent,
        DosDigitosPipe,
        FuseAlertComponent,
        CommandPaletteComponent,
    ],
    providers: [
        JedsMenuService,
        PwaService,
        EnviarEmailModalService,
        AppAlertService,
        FormateadorService,
    ],
})
export class SharedComponentModule { }
